import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NgxSpinnerService } from 'ngx-spinner';

import {
  BackendService,
  ModalService,
  NotificationService,
  TableActionParams,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { EnumService } from '../../../services/enum.service';

@Component({
  selector: 'app-medijumi',
  templateUrl: './medijumi.component.html',
})
export class MedijumiComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Subscription[] = [];
  private _data: any[];

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _enumService: EnumService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSSPO_MED,
          FormName.SifarnikMedijuma,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            this.setSettings(data['Settings']);
          }
          this._data = data['ServiceData'];
          this.orderList = this.setRbr([...this._data]);
          this.setAllFields();
        })
    );
  }

  refreshTable() {
    this.orderList = this.setRbr(this._data);
  }

  addOrder() {
    this._spinner.show();
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSSPO_MED, FormName.PregledSpotova, payload)
        .subscribe(data => {
          this.getServiceErrorMessage(data);
          this.loadSettings();
          this._enumService.fetchMedijumi(true);
        })
    );
  }

  getServiceErrorMessage(data) {
    if (data['Error'] && data['Error']['ErrorMessage']) {
      this._notificationService.notyError(data['Error']['ErrorMessage']);

      return;
    }
  }

  updateOrder() {
    this._spinner.show();
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSSPO_MED, FormName.PregledSpotova, payload)
        .subscribe(data => {
          this.getServiceErrorMessage(data);
          this.loadSettings();
          this._enumService.fetchMedijumi(true);
        })
    );
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSSPO_MED, FormName.PregledSpotova, this.order.Id)
        .subscribe((data: any) => {
          if (data.ServiceData) {
            this._notificationService.openNoty('Uspešno brisanje');
          } else {
            this._notificationService.openNoty('Nije moguće obrisati stavku.');
          }
          this.loadSettings();
          this._enumService.fetchMedijumi(true);
        })
    );
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.updateOrder();
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  onTableInlineSave(event) {
    this.addOrder();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/medijumi/medijumi.component.ts